import { useMutation } from '@tanstack/react-query';
import { Plus, RotateCw } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ModalRegistrationManual from '@/domains/traffic-monitoring//components/ModalRegistrationManual/ModalRegistrationManual';
import { cctvStreamService } from '@/domains/traffic-monitoring/apis/cctv-stream';
import { pscDashboardApi } from '@/domains/traffic-monitoring/apis/psc-dashboard';
import AmbulanceCard from '@/domains/traffic-monitoring/components/AmbulanceCard/AmbulanceCard';
import CardEventPsc from '@/domains/traffic-monitoring/components/CardEventPsc/CardEventPsc';
import HealthcarePoiLegend from '@/domains/traffic-monitoring/components/HealthcarePoiLegend/HealthcarePoiLegend';
import ModalConfirmation from '@/domains/traffic-monitoring/components/ModalConfirmation/ModalConfirmation';
import ModalRegister from '@/domains/traffic-monitoring/components/ModalRegister/ModalRegister';
import type { CctvClickData } from '@/domains/traffic-monitoring/components/SmartCityMaps/SmartCityMaps';
import SmartCityMaps from '@/domains/traffic-monitoring/components/SmartCityMaps/SmartCityMaps';
import StatusFilter from '@/domains/traffic-monitoring/components/StatusFilter/StatusFilter';
import SwitchButton from '@/domains/traffic-monitoring/components/SwitchButton/SwitchButton';
import TabControl from '@/domains/traffic-monitoring/components/TabControl/TabControl';
import VideoModalMaps from '@/domains/traffic-monitoring/components/VideoModalMaps/VideoModalMaps';
import { useCctvNearIncidents } from '@/domains/traffic-monitoring/hooks/useCctvList';
import {
  TERMINAL_EVENT_TYPES,
  usePscDashboard,
} from '@/domains/traffic-monitoring/hooks/usePscDashboard';
import type {
  CardEventPscView,
  ReportManualCreateBody,
} from '@/domains/traffic-monitoring/types/psc-dashboard.types';
// Re-enabling the mock fallback below needs these types back:
// import type {
//   AmbulanceCardView,
//   CardEventPscView,
//   MapMarkerView,
//   PolylineView,
//   TabItemView,
// } from '@/domains/traffic-monitoring/types/psc-dashboard.types';
import Header from '@/shared/components/layout/Header/Header';
import Button from '@/shared/components/ui/Button';
import LogItem from '@/shared/components/ui/LogItem/LogItem';
import RunningText from '@/shared/components/ui/RunningText/RunningText';
import { formatDateToDDMonYYYY, formatTimeOnly } from '@/shared/utils/date';
import { showToast } from '@/shared/utils/showToast';
import { useAuthStore } from '@/store/authStore';
import { ButtonStore } from '@/store/buttonStore';

// const mockTabsFilter: TabItemView[] = [
//   { id: 'active', label: 'Active', count: 3 },
//   { id: 'past', label: 'Past', count: 5 },
// ];
//
// const mockCardData: CardEventPscView[] = [
//   {
//     reportId: 1,
//     typeCard: 'header',
//     eventTypes: 'incoming',
//     action: 'action request',
//     address: 'Jl. Pemuda No. 8, Purwodadi',
//     timer: 3,
//     textButton: 'register & dispatch',
//     showButton: true,
//     showAmbulance: false,
//     ambulances: [
//       { platNumber: 'K8045R', ambulanceTypes: 'accepted' },
//       { platNumber: 'K8045R', ambulanceTypes: 'accepted' },
//     ],
//   },
//   {
//     reportId: 2,
//     typeCard: 'header',
//     eventTypes: 'registered',
//     action: 'action request',
//     address: 'Jl. Pemuda No. 8, Purwodadi',
//     timer: 3,
//     textButton: 'dispatch',
//     showButton: true,
//     showAmbulance: false,
//     ambulances: [
//       { platNumber: 'K8045R', ambulanceTypes: 'requested' },
//       { platNumber: 'K8045R', ambulanceTypes: 'accepted' },
//     ],
//   },
//   {
//     reportId: 3,
//     typeCard: 'header',
//     eventTypes: 'registered',
//     action: 'action request',
//     address: 'Jl. Pemuda No. 8, Purwodadi',
//     timer: 3,
//     textButton: 'dispatch',
//     showButton: true,
//     showAmbulance: true,
//     ambulances: [
//       { platNumber: 'K8045R', ambulanceTypes: 'requested' },
//       { platNumber: 'K8045R', ambulanceTypes: 'rejected' },
//     ],
//   },
//   {
//     reportId: 4,
//     typeCard: 'header',
//     eventTypes: 'dispatched',
//     action: 'action request',
//     address: 'Jl. Pemuda No. 8, Purwodadi',
//     timer: 3,
//     textButton: 'dispatch',
//     showButton: true,
//     showAmbulance: true,
//     ambulances: [
//       { platNumber: 'K8045R', ambulanceTypes: 'requested' },
//       { platNumber: 'K8045R', ambulanceTypes: 'rejected' },
//     ],
//   },
//   {
//     reportId: 5,
//     typeCard: 'default',
//     eventTypes: 'transfer',
//     action: 'action request',
//     address: 'Jl. Pemuda No. 8, Purwodadi',
//     timer: 3,
//     textButton: 'edit',
//     showButton: true,
//     showAmbulance: true,
//     ambulances: [
//       { platNumber: 'K8045R', ambulanceTypes: 'requested' },
//       { platNumber: 'K8045R', ambulanceTypes: 'rejected' },
//     ],
//   },
// ];
//
// const mockAmbulanceData: AmbulanceCardView[] = [
//   { id: 1, platNumber: 'K3350', ambulanceDriverTypes: 'ongoing', address: 'RSUD Dr. SOEDJATI SOEMODIARDJO ' },
//   { id: 2, platNumber: 'B1234CD', ambulanceDriverTypes: 'standby', address: 'RSUD Dr. SOEDJATI SOEMODIARDJO ' },
//   { id: 3, platNumber: 'B1234CD', ambulanceDriverTypes: 'maintenance', address: 'RSUD Dr. SOEDJATI SOEMODIARDJO ' },
//   { id: 4, platNumber: 'B1234CD', ambulanceDriverTypes: 'maintenance', address: 'RSUD Dr. SOEDJATI SOEMODIARDJO ' },
//   { id: 5, platNumber: 'B1234CD', ambulanceDriverTypes: 'offline', address: 'RSUD Dr. SOEDJATI SOEMODIARDJO ' },
// ];
//
// const mockFilterData: FilterItem[] = [
//   { id: 'all', label: 'All', total: 8 },
//   { id: 'standby', label: 'Standby', total: 3 },
//   { id: 'maintenance', label: 'Maintenance', total: 4 },
//   { id: 'ongoing', label: 'On-Going', total: 7 },
//   { id: 'offline', label: 'Offline', total: 2 },
// ];
//
// const mockCoords = {
//   lat: 35.8714,
//   lng: 128.6014,
// };
//
// const mockMarkers: MapMarkerView[] = [
//   {
//     id: 'ambulance-01',
//     lat: 35.8714,
//     lng: 128.6014,
//     type: 'Ambulance',
//     tooltip: { title: 'TRANSFER', description: 'AMB33150001 | K8035 XP' },
//   },
//   {
//     id: 'incident-01',
//     lat: 35.8725,
//     lng: 128.6025,
//     type: 'Incident',
//     tooltip: { title: 'Incident Location', description: 'Arrived at 13:05' },
//   },
//   {
//     id: 'start-01',
//     lat: 35.8735,
//     lng: 128.6035,
//     type: 'StartPoint',
//     tooltip: { title: 'Starting Point', description: '106.845130,-6.214623' },
//   },
//   {
//     id: 'wifi-01',
//     lat: 35.8745,
//     lng: 128.6075,
//     type: 'Wifi',
//     tooltip: { title: 'Wifi', description: 'RSUD Habibullah' },
//   },
//   {
//     id: 'mosque-01',
//     lat: 35.8746,
//     lng: 128.6076,
//     type: 'Mosque',
//     tooltip: { title: 'Mosque', description: 'RSUD Habibullah' },
//   },
// ];
//
// const mockPolylines: PolylineView[] = [
//   {
//     id: 'route1',
//     color: '#00A2FF',
//     width: 4,
//     points: [
//       [128.6014, 35.8714],
//       [128.6025, 35.8725],
//       [128.6035, 35.8735],
//     ],
//   },
// ];
// ---------------------------------------------------------------------------

// Grobogan, Central Java - where every live marker (map/poi, ambulance routes)
const liveCoords = {
  lat: -7.03,
  lng: 110.92,
};

const CCTV_RADIUS_M = 1000;

const DEVICE_STATUS_TO_TYPE: Record<string, 'online' | 'offline' | 'maintenance'> = {
  DEV_ST_ON: 'online',
  DEV_ST_OFF: 'offline',
  DEV_ST_MTN: 'maintenance',
};

// cm_language tags for the labels this page builds client-side (tabs, ambulance
// status chips, card action buttons). Register/edit the wording itself in
// System Management > Language; only the tag names live here.
const TAB_TAGS: Record<string, string> = {
  active: 'psc>report>active',
  past: 'psc>report>past',
};

const AMBULANCE_FILTER_TAGS: Record<string, string> = {
  all: 'psc>ambulance>all',
  standby: 'psc>ambulance>standby',
  maintenance: 'psc>ambulance>maintenance',
  ongoing: 'psc>ambulance>on-going',
  offline: 'psc>ambulance>offline',
};

// Keyed by usePscDashboard.ts's EVENT_TYPE_TO_TEXT_BUTTON values (and its
// 'redispatch' override for a report with a prior ambulance rejection).
const TEXT_BUTTON_TAGS: Record<string, string> = {
  'register & dispatch': 'psc>report>register&dispatch',
  dispatch: 'psc>report>dispatch',
  redispatch: 'psc>report>re-dispatch',
  edit: 'psc>report>edit',
  detail: 'psc>report>detail',
  complete: 'psc>report>complete report',
  'see-details': 'psc>report>see details',
};

// Maps a card's action button to the next screen for that report - see
// usePscDashboard.ts's EVENT_TYPE_TO_TEXT_BUTTON for how textButton is derived.
const reportActionRoute = (textButton: string): string => {
  if (textButton === 'dispatch' || textButton === 'redispatch') {
    return '/dashboard/ambulance-dashboard';
  }
  // 'complete' (a finished-but-not-yet-completed report) still goes to the
  // details page - the actual completion click lives there, not on the card.
  if (
    textButton === 'edit' ||
    textButton === 'detail' ||
    textButton === 'complete' ||
    textButton === 'see-details'
  ) {
    return '/dashboard/details-dashboard';
  }
  return '/dashboard/regis-dashboard';
};

const PSCDashboard = () => {
  const { t } = useTranslation();
  // Falls back to the raw label when a tag isn't registered in cm_language yet.
  const translateTag = (tags: Record<string, string>, key: string, fallback: string): string => {
    const tag = tags[key];
    return tag ? t(tag) : fallback;
  };
  const [activeTab, setActiveTab] = useState('active');
  const [reportSearch, setReportSearch] = useState('');
  const [ambulanceSearch, setAmbulanceSearch] = useState('');
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState('all');
  const accountType = useAuthStore((s) => s.account_type);
  const live = usePscDashboard();
  // Mock-fallback version (shows fake data whenever a live query is empty,
  // instead of a genuine empty state) - kept for reference, not active:
  // const cardData = live.cardData.length > 0 ? live.cardData : mockCardData;
  // const tabsFilter = live.cardData.length > 0 ? live.tabsFilter : mockTabsFilter;
  // const ambulanceData = live.ambulanceData.length > 0 ? live.ambulanceData : mockAmbulanceData;
  // const filterData = live.ambulanceData.length > 0 ? live.filterData : mockFilterData;
  // const markers = live.markers.length > 0 ? live.markers : mockMarkers;
  // const polylines = live.polylines.length > 0 ? live.polylines : mockPolylines;
  // const coords = live.markers.length > 0 ? liveCoords : mockCoords;

  const displayedCardData = live.cardData
    .filter((card) =>
      activeTab === 'past'
        ? TERMINAL_EVENT_TYPES.includes(card.eventTypes)
        : !TERMINAL_EVENT_TYPES.includes(card.eventTypes)
    )
    .filter((card) => {
      const term = reportSearch.trim().toLowerCase();
      if (!term) return true;
      return (
        card.address.toLowerCase().includes(term) ||
        String(card.report_code_id ?? '')
          .toLowerCase()
          .includes(term)
      );
    });
  // The "running text" banner is a single latest-activity notification across
  // every report, active or past - a new report, a status change, an
  // ambulance update, or a report being rejected/completed all move a
  // report's lastActivityTime forward, so the max of that field (not just
  // the newest-registered report) is the one to surface.
  const newestCard = live.cardData.reduce<CardEventPscView | null>((latest, card) => {
    const cardTime = card.lastActivityTime ? new Date(card.lastActivityTime).getTime() : 0;
    const latestTime = latest?.lastActivityTime ? new Date(latest.lastActivityTime).getTime() : 0;
    return !latest || cardTime > latestTime ? card : latest;
  }, null);
  const ambulanceData = live.ambulanceData;
  const filterData = live.filterData.map((item) => ({
    ...item,
    label: translateTag(AMBULANCE_FILTER_TAGS, item.id, item.label),
  }));
  const tabsFilter = live.tabsFilter.map((tab) => ({
    ...tab,
    label: translateTag(TAB_TAGS, tab.id, tab.label),
  }));
  // Past-tab (completed/rejected) reports' incident pins are greyed out on
  // the map rather than the normal red - the map/poi 'incident' layer has no
  // notion of the front-end's own Active/Past split, so it's applied here
  // against live.cardData (the same source deriving the tab split above).
  const terminalReportIds = new Set(
    live.cardData
      .filter((card) => TERMINAL_EVENT_TYPES.includes(card.eventTypes))
      .map((card) => card.reportId)
  );
  const showCctv = ButtonStore((state) =>
    (state.activeIdsMap.filterMaps || []).includes('filterICon')
  );
  const showOfflineAmbulance = ButtonStore((state) =>
    (state.activeIdsMap.filterMaps || []).includes('filterOfflineAmbulance')
  );
  const showAllHealthcare = ButtonStore((state) =>
    (state.activeIdsMap.filterMaps || []).includes('filterAllHealthcare')
  );
  // Facilities with at least one ongoing (AMB_ST_ONGO) ambulance - what the
  // healthcare POI toggle falls back to showing when it's off.
  const facilitiesWithOngoingAmbulance = new Set(
    ambulanceData
      .filter(
        (item) => item.ambulanceDriverTypes === 'ongoing' && item.healthCareFacilityId != null
      )
      .map((item) => item.healthCareFacilityId as number)
  );
  const markers = live.markers
    .map((marker) =>
      marker.type === 'Incident' &&
      marker.reportId != null &&
      terminalReportIds.has(marker.reportId)
        ? { ...marker, type: 'IncidentCompleted' }
        : marker
    )
    .filter((marker) => showOfflineAmbulance || !marker.isOffline)
    .filter(
      (marker) =>
        marker.type !== 'healthcarepoi' ||
        showAllHealthcare ||
        (marker.facilityId != null && facilitiesWithOngoingAmbulance.has(marker.facilityId))
    );
  const polylines = live.polylines;
  const coords = liveCoords;
  const [expandedCctv, setExpandedCctv] = useState<CctvClickData | null>(null);
  const activeIncidentPositions = live.cardData
    .filter(
      (card) => card.eventTypes !== 'incoming' && !TERMINAL_EVENT_TYPES.includes(card.eventTypes)
    )
    .map((card) => markers.find((marker) => marker.id === `incident-${card.reportId}`))
    .filter((marker): marker is (typeof markers)[number] => !!marker)
    .map((marker) => ({ lat: marker.lat, lng: marker.lng }));
  const { cctvList } = useCctvNearIncidents(showCctv ? activeIncidentPositions : [], CCTV_RADIUS_M);
  const cctvMarkers = cctvList
    .filter((item) => item.latitude != null && item.longitude != null)
    .map((item) => ({
      id: `cctv-${item.cctv_id}`,
      lat: item.latitude as number,
      lng: item.longitude as number,
      type: 'cctvpoi',
      tooltip: { title: item.name, description: item.device_status_name },
      cctv: {
        name: item.name,
        address: item.address,
        latlong: `${item.latitude}, ${item.longitude}`,
        streamUrl: cctvStreamService.getHlsUrl(item),
        typeVideo: DEVICE_STATUS_TO_TYPE[item.device_status] ?? 'maintenance',
      },
    }));
  const mapMarkers = [...markers, ...cctvMarkers];

  // Ambulance/report card click → fly the map to that marker's location.
  // nonce bumps each click so clicking the same card twice still re-triggers
  // the animation (matches MainDashboard.tsx's own focusTarget pattern).
  const [focusTarget, setFocusTarget] = useState<{
    lat: number;
    lng: number;
    nonce: number;
    id?: string;
    ids?: string[];
  } | null>(null);
  const markersById = new Map(markers.map((marker) => [marker.id, marker]));
  const focusOnMarker = (markerId: string) => {
    const marker = markersById.get(markerId);
    if (!marker) return;
    setFocusTarget((prev) => ({
      lat: marker.lat,
      lng: marker.lng,
      nonce: (prev?.nonce ?? 0) + 1,
      id: markerId,
    }));
  };
  // Frames every marker in `markerIds` at once (fit-to-bounds instead of a
  // single fly-to-point) - used when a report has related on-going
  // ambulances, so the incident and those ambulances all land in view
  // together. Falls back to a plain single-marker focus when only one
  // marker id resolves (e.g. every related ambulance is currently off-map).
  const focusOnMarkers = (markerIds: string[]) => {
    const validIds = markerIds.filter((id) => markersById.has(id));
    const [firstId] = validIds;
    if (!firstId) return;
    if (validIds.length === 1) {
      focusOnMarker(firstId);
      return;
    }
    const anchor = markersById.get(firstId);
    if (!anchor) return;
    setFocusTarget((prev) => ({
      lat: anchor.lat,
      lng: anchor.lng,
      nonce: (prev?.nonce ?? 0) + 1,
      ids: validIds,
    }));
  };
  // Report card click → also frame its related on-going ambulance(s) (fleet
  // roster status, not the report's own per-ambulance status) alongside the
  // incident, matched by plate number since the report's ambulance entries
  // don't carry the ambulance/roster id the map marker is keyed on.
  const ambulanceByPlate = new Map(ambulanceData.map((item) => [item.platNumber, item]));
  const getOngoingAmbulanceMarkerIds = (card: CardEventPscView): string[] =>
    card.ambulances
      .map((ambulance) => ambulanceByPlate.get(ambulance.platNumber))
      .filter(
        (item): item is (typeof ambulanceData)[number] =>
          !!item && item.ambulanceDriverTypes === 'ongoing'
      )
      .map((item) => `ambulance-${item.id}`);

  const filteredAmbulance = ambulanceData
    .filter((item) => selectedFilter === 'all' || item.ambulanceDriverTypes === selectedFilter)
    .filter((item) => {
      const term = ambulanceSearch.trim().toLowerCase();
      if (!term) return true;
      return (
        item.platNumber.toLowerCase().includes(term) || item.address.toLowerCase().includes(term)
      );
    });

  const [activeModal, setActiveModal] = useState<
    'ModalRegistrationManual' | 'close' | 'regis' | null
  >(null);

  const closeModal = () => setActiveModal(null);

  const [manualReportDraft, setManualReportDraft] = useState<ReportManualCreateBody | null>(null);

  const createManualReportMutation = useMutation({
    mutationFn: (body: ReportManualCreateBody) => pscDashboardApi.postReportManualCreate(body),
  });

  const handleManualRegisterConfirm = () => {
    if (!manualReportDraft) return;
    createManualReportMutation.mutate(manualReportDraft, {
      onSuccess: (res) => {
        closeModal();
        setManualReportDraft(null);
        showToast({
          type: 'info',
          title: t('psc>msg>report created'),
          message: t('psc>msg>report created detail'),
        });
        if (res?.data?.report_id) {
          navigate(`/dashboard/ambulance-dashboard?reportId=${res.data.report_id}`);
        }
      },
      onError: (error: unknown) => {
        showToast({
          type: 'error',
          title: t('psc>msg>registration failed'),
          message: (error as Error)?.message ?? t('psc>msg>failed create report'),
        });
      },
    });
  };

  return (
    <main className="_pscDashboard bg-db-wrap flex flex-col  w-full h-screen  overflow-hidden">
      <Header />

      <div className="flex-1 grid grid-cols-[1fr_2.5fr_1fr] w-full h-full min-h-0 overflow-hidden ">
        {/* section left */}
        <section className="w-full flex  flex-col h-full border-r bg-db-card bg-db-border ">
          <div className="w-full h-full overflow-hidden flex flex-col gap-6 p-6 ">
            <div className="w-full inline-flex justify-between items-center gap-3">
              <span className="title1bold text-db-text capitalize">{t('psc>master>report')}</span>
              <Button
                onClick={() => setActiveModal('ModalRegistrationManual')}
                variant="default"
                className="w-fit rounded-full btn-fill-blue capitalize "
              >
                <Plus />
                <span className="title1">{t('psc>report>add new')}</span>
              </Button>
            </div>
            <div className="gap-3 flex flex-col">
              <input
                type="text"
                className="input-db-text rounded-[50px]!  "
                placeholder={t('psc>report>search report')}
                value={reportSearch}
                onChange={(e) => setReportSearch(e.target.value)}
              />
              <TabControl tabs={tabsFilter} activeTab={activeTab} onChange={setActiveTab} />
            </div>
            <div className=" overflow-psc-card flex flex-col gap-3 overflow-hidden h-[calc(95vh-100px)] ">
              <div className="flex flex-col gap-3 overflow-auto h-full pb-[120px] ">
                {displayedCardData.map((card) => (
                  <CardEventPsc
                    onWhatsApp={() =>
                      navigate(`/dashboard/regis-dashboard?reportId=${card.reportId}`)
                    }
                    key={card.reportId}
                    report_code_id={card.report_code_id}
                    {...card}
                    showChannelIcon={accountType !== 'healthcare'}
                    textButton={translateTag(TEXT_BUTTON_TAGS, card.textButton, card.textButton)}
                    ambulances={card.ambulances.map((ambulance) => {
                      const driverType = ambulanceByPlate.get(
                        ambulance.platNumber
                      )?.ambulanceDriverTypes;
                      return {
                        ...ambulance,
                        isNotOffline: driverType != null && driverType !== 'offline',
                      };
                    })}
                    onClick={() =>
                      navigate(`${reportActionRoute(card.textButton)}?reportId=${card.reportId}`)
                    }
                    onCardClick={
                      markersById.has(`incident-${card.reportId}`)
                        ? () =>
                            focusOnMarkers([
                              `incident-${card.reportId}`,
                              ...getOngoingAmbulanceMarkerIds(card),
                            ])
                        : undefined
                    }
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* section left */}

        {/* section center */}
        <section className=" section-maps-psc w-full h-[calc(100vh-6vh)] relative bg-db-card ">
          <div className="absolute top-2 right-2 z-10 p-2  rounded-[12px] overflow-hidden flex flex-col gap-2 bg-[#fff]/60 min-w-[200px] backdrop-blur-sm  border border-db-border">
            <div className="inline-flex gap-3 items-center justify-between">
              <span className="text-text-grey dark:text-white body1">Show CCTV</span>
              <SwitchButton id="filterICon" groupKey="filterMaps" />
            </div>
            <div className="inline-flex gap-3 items-center justify-between">
              <span className="text-text-grey dark:text-white body1">Offline Ambulance</span>
              <SwitchButton id="filterOfflineAmbulance" groupKey="filterMaps" />
            </div>
            <div className="inline-flex gap-3 items-center justify-between">
              <span className="text-text-grey dark:text-white body1">All Healthcare POI</span>
              <SwitchButton id="filterAllHealthcare" groupKey="filterMaps" />
            </div>
            <HealthcarePoiLegend className="border-t border-db-border pt-2" />
          </div>
          <div className="flex-1 h-full relative flex w-full">
            <SmartCityMaps
              coords={coords}
              markers={mapMarkers}
              polylines={polylines}
              focusTarget={focusTarget}
              onCctvExpand={setExpandedCctv}
              hideCoordinates
              // Per-type healthcare badges, keyed by HealthcarePoiLegend above.
              healthcareTypeIcons
            />
          </div>
          <div className="absolute w-full bottom-0 z-999">
            <RunningText
              isEmpty={!newestCard}
              time={newestCard?.lastActivityTime ? formatTimeOnly(newestCard.lastActivityTime) : ''}
              idPsc={String(newestCard?.report_code_id ?? '')}
              eventTypes={newestCard?.eventTypes ?? 'registered'}
              ambulance={
                newestCard?.lastActivityAmbulance
                  ? {
                      plateNumber: newestCard.lastActivityAmbulance.police_number ?? '',
                      ambulanceType: newestCard.lastActivityAmbulance.ambulance_type,
                      statusLabel: newestCard.lastActivityAmbulance.ambulance_type_label,
                    }
                  : null
              }
            />
          </div>
        </section>
        {/* section center */}

        {/* section right */}
        <section className="w-full h-full border-l bg-db-card bg-db-border">
          <div className="w-full h-full overflow-hidden flex flex-col gap-6 p-6 ">
            <span className="title1bold text-db-text capitalize">
              {t('psc>ambulance>ambulance management')}
            </span>
            <div className="gap-3 flex flex-col">
              <input
                type="text"
                className="input-db-text rounded-[50px]!  "
                placeholder={t('psc>ambulance>search ambulance')}
                value={ambulanceSearch}
                onChange={(e) => setAmbulanceSearch(e.target.value)}
              />
              <div className="w-full flex flex-row flex-wrap gap-3">
                <StatusFilter
                  items={filterData}
                  value={selectedFilter}
                  onChange={setSelectedFilter}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 overflow-hidden h-[calc(95vh-100px)] ">
              <div className="flex flex-col gap-3 overflow-auto h-full pb-[180px] ">
                {filteredAmbulance.map((item) => (
                  <AmbulanceCard
                    key={item.id}
                    platNumber={item.platNumber}
                    address={item.address}
                    ambulanceDriverTypes={item.ambulanceDriverTypes}
                    onClick={
                      markersById.has(`ambulance-${item.id}`)
                        ? () => focusOnMarker(`ambulance-${item.id}`)
                        : undefined
                    }
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* section right */}
      </div>
      <ModalRegister
        isOpen={activeModal === 'close'}
        typeModal="close"
        timesTamp={`${formatDateToDDMonYYYY(new Date())} · ${formatTimeOnly(new Date())}`}
        onEdit={() => setActiveModal('ModalRegistrationManual')}
        onClose={closeModal}
      />

      <ModalRegister
        isOpen={activeModal === 'regis'}
        timesTamp={`${formatDateToDDMonYYYY(new Date())} · ${formatTimeOnly(new Date())}`}
        onClose={closeModal}
        onRegister={handleManualRegisterConfirm}
      />

      <ModalRegistrationManual
        isOpen={activeModal === 'ModalRegistrationManual'}
        onClose={() => setActiveModal('close')}
        onRegister={(data) => {
          setManualReportDraft(data);
          setActiveModal('regis');
        }}
      />

      <VideoModalMaps
        isOpen={!!expandedCctv}
        address={expandedCctv?.address ?? ''}
        name={expandedCctv?.name ?? ''}
        latlong={expandedCctv?.latlong ?? ''}
        streamUrl={expandedCctv?.streamUrl ?? undefined}
        typeVideo={expandedCctv?.typeVideo ?? 'offline'}
        onClick={() => setExpandedCctv(null)}
      />
    </main>
  );
};

export default PSCDashboard;
